"use client";

import type React from "react";
import styles from "./styles.module.css";

const ItemSkeleton: React.FC = () => {
	return (
		<div className={styles.item}>
			<div className={styles.thumb} />
			<div className={styles.body}>
				<div className={styles.priceRow}>
					<div className={styles.price} />
					<div className={styles.priceSmall} />
				</div>
				<div className={styles.address} />
			</div>
		</div>
	);
};

const CatalogMapSkeleton: React.FC = () => {
	return (
		<div className={styles.wrap}>
			{Array.from({ length: 6 }).map((_, i) => (
				<ItemSkeleton key={i} />
			))}
		</div>
	);
};

export default CatalogMapSkeleton;
